import { Shield, User, Globe } from 'lucide-react'
import { useI18n } from '../i18n'

/**
 * TrustBar v179.0.0
 * 
 * Static 3-item inline icon strip: HIPAA · Your Data · Multilingual.
 * No animation, no rotation. Each item individually tappable for detail sheets.
 * Muted blue-gray text, brand-colored icons.
 */

const TRUST_ITEMS = [
  { icon: Shield, labelKey: 'home.trust.hipaa',        tapTarget: 'hipaa',    iconColor: '#46A8F9' },
  { icon: User,   labelKey: 'home.trust.yourData',     tapTarget: 'data',     iconColor: '#46A8F9' },
  { icon: Globe,  labelKey: 'home.trust.multilingual', tapTarget: 'language', iconColor: '#46A8F9' },
]

export default function TrustBar({ onTap }) {
  const { t } = useI18n()

  return (
    <div className="flex items-center justify-center">
      <div className="flex items-center gap-3.5">
        {TRUST_ITEMS.map((item, idx) => {
          const Icon = item.icon
          return (
            <div key={item.tapTarget} className="flex items-center gap-3.5">
              {idx > 0 && (
                <div className="w-[3px] h-[3px] rounded-full" style={{ background: '#CBD5E1' }} />
              )}
              <button
                onClick={() => onTap?.(item.tapTarget)}
                className="flex items-center gap-1 active:scale-[0.96] transition-transform"
                style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
              >
                <Icon size={13} strokeWidth={2.5} color={item.iconColor} />
                <span style={{ fontSize: '12px', fontWeight: 600, color: '#8BA7BC' }}>
                  {t(item.labelKey)}
                </span>
              </button>
            </div>
          )
        })}
      </div>
    </div>
  )
}
